import { useReportCtx } from '@app/core/reports/report-ctx';
import { generateShortHash } from '@app/modules/audit/helpers';
import { OrderReprocessAction } from '@app/modules/audit/modules/aod/components/order-reprocess';
import { auditReports } from '@mi-front/api-clients';
import { ChipNavigationProps } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useMemo } from 'react';
import { GipAlternativeReportType } from '../gip-alt-report/preview/types';
import { GipReportType } from '../gip-report/config/form/types';
import { GipReportStatsSummary } from '../gip-report/preview/components/result/GipReportStatsSummary';
import { GipReportChipNavigation } from './GipReportChipNavigation';

export interface GipReportStatsAndNavigationProps {
  additionalChips?: ChipNavigationProps['chips'];
  defaultActiveChip?: string;
  wrapNavigation?: boolean;
}

export const GipReportStatsAndNavigation = ({
  additionalChips,
  defaultActiveChip = 'with-matches',
  wrapNavigation = false,
}: GipReportStatsAndNavigationProps) => {
  const ctx = useReportCtx<GipReportType | GipAlternativeReportType>();
  const result = ctx.result as auditReports.GipReportResultDto | auditReports.GipAltReportResultDto;
  const values = ctx.values as GipReportType['Values'];

  const reprocessKey = useMemo(
    () =>
      generateShortHash({
        orders: values.orders,
        from: values.from,
        to: values.to,
      }),
    [values.orders, values.from, values.to],
  );

  const navigation = (
    <GipReportChipNavigation
      result={result}
      additionalChips={additionalChips}
      defaultActiveChip={defaultActiveChip}
      actionComponent={
        result.meta.canReprocess && (
          <OrderReprocessAction
            orders={values.orders}
            reprocessKey={reprocessKey}
            onReprocessComplete={() => {
              ctx.refreshReport();
            }}
          />
        )
      }
    />
  );

  return (
    <>
      <GipReportStatsSummary result={result} />
      {wrapNavigation ? (
        <Box display="flex" gap={2}>
          {navigation}
        </Box>
      ) : (
        navigation
      )}
    </>
  );
};
